import React from 'react';

import { Assets } from '@assets';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';

export const EmailQuoteFailed: React.FC = () => (
  <div className="flex flex-col  items-center justify-center space-y-5 pb-3">
    <Assets.ToolsCircle width={72} />
    <Text variant="h3-28/sb" className="text-left">
      {i18n.t('emailQuote.emailQuoteFailed.title')}
    </Text>
    <Text variant="body-16/r">{i18n.t('emailQuote.emailQuoteFailed.subtitle')}</Text>
    <div className="flex items-center border-t px-3 border-fuji-300 border-opacity-30 ">
      <Text variant="body-16/r" className="py-4 text-center">
        {i18n.t('emailQuote.emailQuoteFailed.description')}
      </Text>
    </div>
    <Button
      variant="primary"
      className="w-full"
      title={i18n.t('emailQuote.emailQuoteFailed.contactNumber')}
    />
  </div>
);
